<!-- Overlay behind the drawer (tablet / mobile only; hidden on desktop by CSS) -->
<div class="mobile-overlay" *ngIf="isMobileMenuOpen$ | async" (click)="closeMobileMenu()"></div>

<aside id="app-sidebar" [class.collapsed]="(isCollapsed$ | async)" [class.mobile-open]="(isMobileMenuOpen$ | async)" class="sidebar">
    <!-- Sidebar header: same height as the topbar, so logo + arrow line up with it -->
    <div class="sidebar-header">
      <!-- Logo Section (collapsed desktop: logo mark only; text hidden via CSS) -->
      <div class="logo-section" (click)="gotoDashboard()" (keyup.enter)="gotoDashboard()"
           role="button" tabindex="0" aria-label="VitaGist dashboard">
        <img src="assets/images/vitalogo.png" alt="VitaGist" class="logo" />
        <span class="logo-text">Vita<span class="half-text">Gist</span></span>
      </div>

      <!-- Desktop collapse / expand pill (hidden in drawer mode by CSS) -->
      <button type="button" class="collapse-toggle" (click)="toggleSidebar()"
              [attr.aria-label]="(isCollapsed$ | async) ? 'Expand sidebar' : 'Collapse sidebar'"
              [attr.aria-expanded]="!(isCollapsed$ | async)"
              [title]="(isCollapsed$ | async) ? 'Expand sidebar' : 'Collapse sidebar'">
        <i class="bi" [ngClass]="(isCollapsed$ | async) ? 'bi-chevron-right' : 'bi-chevron-left'" aria-hidden="true"></i>
      </button>

      <!-- Drawer close button (tablet / mobile only) -->
      <button type="button" class="drawer-close-btn" *ngIf="isMobileMenuOpen$ | async"
              (click)="closeMobileMenu()" aria-label="Close menu" title="Close menu">
        <i class="bi bi-x-lg" aria-hidden="true"></i>
      </button>
    </div>

    <!-- Navigation Links -->
    <nav class="nav-links" aria-label="Main navigation">
    <a routerLink="/dashboard" routerLinkActive="active" class="nav-item" [routerLinkActiveOptions]="{ exact: true }" [class.collapsed]="(isCollapsed$ | async)" (click)="onOptionClick('Dashboard')" (mouseenter)="showTooltip($event, 'Dashboard')" (mouseleave)="hideTooltip()" (focus)="showTooltip($event, 'Dashboard')" (blur)="hideTooltip()">
      <img src="assets/icons/dashboard.png" alt="Dashboard" class="nav-icon" />
      <span class="nav-text">Dashboard</span>
    </a>

    <a routerLink="/health" routerLinkActive="active" class="nav-item" [class.collapsed]="(isCollapsed$ | async)" [ngClass]="{ active: isHealthActive() }" (click)="onOptionClick('Health')" (mouseenter)="showTooltip($event, 'Health')" (mouseleave)="hideTooltip()" (focus)="showTooltip($event, 'Health')" (blur)="hideTooltip()">
      <img src="assets/icons/healthi.png" alt="Health" class="nav-icon" />
      <span class="nav-text">Health</span>
    </a>

    <a routerLink="/documents" routerLinkActive="active" class="nav-item" [routerLinkActiveOptions]="{ exact: false }" [class.collapsed]="(isCollapsed$ | async)" (click)="onOptionClick('Documents')" (mouseenter)="showTooltip($event, 'Documents')" (mouseleave)="hideTooltip()" (focus)="showTooltip($event, 'Documents')" (blur)="hideTooltip()">
      <img src="assets/icons/docuemnti.png" alt="Documents" class="nav-icon" />
      <span class="nav-text">Documents</span>
    </a>

    <a routerLink="/connections" routerLinkActive="active" class="nav-item" [routerLinkActiveOptions]="{ exact: true }" [class.collapsed]="(isCollapsed$ | async)" (click)="onOptionClick('Connections')" (mouseenter)="showTooltip($event, 'Connections')" (mouseleave)="hideTooltip()" (focus)="showTooltip($event, 'Connections')" (blur)="hideTooltip()">
      <img src="assets/icons/connectioni.png" alt="Connections" class="nav-icon" />
      <span class="nav-text">Connections</span>
    </a>

    <a routerLink="/calendar" routerLinkActive="active" class="nav-item" [routerLinkActiveOptions]="{ exact: true }" [class.collapsed]="(isCollapsed$ | async)" (click)="onOptionClick('Calendar')" (mouseenter)="showTooltip($event, 'Calendar')" (mouseleave)="hideTooltip()" (focus)="showTooltip($event, 'Calendar')" (blur)="hideTooltip()">
      <img src="assets/icons/calendari.png" alt="Calendar" class="nav-icon" />
      <span class="nav-text">Calendar</span>
    </a>

    <a routerLink="/chats" routerLinkActive="active" class="nav-item" [routerLinkActiveOptions]="{ exact: true }" [class.collapsed]="(isCollapsed$ | async)" (click)="onOptionClick('Chats')" (mouseenter)="showTooltip($event, 'Chats')" (mouseleave)="hideTooltip()" (focus)="showTooltip($event, 'Chats')" (blur)="hideTooltip()">
      <img src="assets/icons/chati.png" alt="Chats" class="nav-icon" />
      <span class="nav-text">Chats</span>
    </a>

    <a routerLink="/notifications" routerLinkActive="active" class="nav-item" [routerLinkActiveOptions]="{ exact: true }"
        [class.collapsed]="(isCollapsed$ | async)" (click)="onOptionClick('Notifications')"
        (mouseenter)="showTooltip($event, 'Notifications')" (mouseleave)="hideTooltip()" (focus)="showTooltip($event, 'Notifications')" (blur)="hideTooltip()">
      <img src="assets/icons/notificationi.png" alt="Notifications" class="nav-icon" />
      <span class="nav-text">Notifications
      <!-- badge -->
      <button class="notification-btn" (click)="toggleNotifications()">
        <span class="notification-badge" *ngIf="notificationCount > 0">
          {{ notificationCount }}
        </span>
      </button>
      <!-- badge -->
      </span>
    </a>

    <a routerLink="/audittrails" routerLinkActive="active" class="nav-item" [routerLinkActiveOptions]="{ exact: true }"
        [class.collapsed]="(isCollapsed$ | async)" (click)="onOptionClick('AuditTrails')"
        (mouseenter)="showTooltip($event, 'Audit Trails')" (mouseleave)="hideTooltip()" (focus)="showTooltip($event, 'Audit Trails')" (blur)="hideTooltip()">
      <img src="assets/icons/audittrailsi.png" alt="AuditTrails" class="nav-icon" />
      <span class="nav-text">Audit Trails</span>
    </a>

    <!-- <a routerLink="/settings" routerLinkActive="active" class="nav-item" [routerLinkActiveOptions]="{ exact: true }"
        [class.collapsed]="(isCollapsed$ | async)" (click)="onOptionClick('Settings')">
      <i class="material-icons">settings</i>
      <span class="nav-text" *ngIf="!(isCollapsed$ | async)">Settings</span>
    </a> -->
     <a routerLink="/settings" class="nav-item" [ngClass]="{ active: isSettingsActive() }"
          [class.collapsed]="(isCollapsed$ | async)" (click)="onOptionClick('Settings')"
          (mouseenter)="showTooltip($event, 'Settings')" (mouseleave)="hideTooltip()" (focus)="showTooltip($event, 'Settings')" (blur)="hideTooltip()">
          <img src="assets/icons/settingsi.png" alt="Settings" class="nav-icon" />
          <span class="nav-text">Settings</span>
     </a>
      
      <a routerLink="" class="nav-item" [class.collapsed]="(isCollapsed$ | async)" (click)="onLogout()"
          (mouseenter)="showTooltip($event, 'Logout')" (mouseleave)="hideTooltip()" (focus)="showTooltip($event, 'Logout')" (blur)="hideTooltip()">
          <img src="assets/icons/logouti.png" alt="Logout" class="nav-icon" />
          <span class="nav-text">Logout</span>
      </a>
    </nav>
  </aside>

  <!-- Tooltip: desktop icon-only sidebar -->
  <div class="sidebar-tooltip"
       *ngIf="tooltipVisible && (isCollapsed$ | async) && !(isMobileMenuOpen$ | async)"
       [style.top.px]="tooltipTop"
       [style.left.px]="tooltipLeft"
       role="tooltip">
    {{ tooltipText }}
  </div>